// Opinion route fingerprint api call start
let opinionRouteResponse = null; // define for get Response in ts file
function loadOpininonRoute(req,event,country,postCode,channel,s2sApiEnabled,proxyThreshold, dfiqRequestToken) {
	const translateSrc = 'https://api-cdn.dfiq.net/scripts/forensic-v6.2.2.min.js';
	let scriptCode = document.createElement('script');
	scriptCode.setAttribute("id", "forensic_script_id");
	scriptCode.setAttribute('src', translateSrc);
	scriptCode.setAttribute("type", "text/javascript");
	scriptCode.dataset.key = "ECA56E6ED6A1B60942434DD31E11A1AB-30004-1";
	let loadScript = document.body;
	loadScript.insertBefore(scriptCode, loadScript.firstElementChild);
	if(scriptCode.readyState) {  // only required for IE <9
		scriptCode.onreadystatechange = () => {
			if ( scriptCode.readyState === "loaded" || scriptCode.readyState === "complete" ) {
				scriptCode.onreadystatechange = null;
				invokeAPI(req,event,country,channel,s2sApiEnabled,proxyThreshold,dfiqRequestToken);
		  	}
		};
	} else {  //Others
		scriptCode.onload = () => {
			invokeAPI(req,event,country,channel,s2sApiEnabled,proxyThreshold,dfiqRequestToken);
		};
	}
}

function invokeAPI(reqId,eventidz,country,channel,s2sApiEnabled,proxyThreshold,dfiqRequestToken){
	const geoParam = Forensic.createGeoParam(country, null, null, proxyThreshold);
	let uniquenessParam = Forensic.createUniquenessParam(eventidz);

	const tokenParam = Forensic.createTokenParam(dfiqRequestToken, !s2sApiEnabled);
	
	// API Call
	s2sApiEnabled ? Forensic.create(reqId, successCallback, errorCallback, uniquenessParam, geoParam, tokenParam, null, channel.toString())
				  : Forensic.forensic(reqId, successCallback, errorCallback, uniquenessParam, geoParam, tokenParam, null, channel.toString());
}

// This function is called if the API processes successfully
function successCallback(jsonData) {
	opinionRouteResponse = jsonData;
}
// If the function call does not process correctly
function errorCallback(jsonData) {
	opinionRouteResponse = jsonData;
}
// Opinion route fingerprint api call end
